// extracted by mini-css-extract-plugin
module.exports = {"morebtn":"yAZ_9","lighBgBtn":"G5gBh","text_white":"dKxNs","downmorebtn":"Dwu2F","isNoLink":"aaZyq"};